export default "__VITE_ASSET__6wlOHud$__"